<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="资源url" prop="url">
          <el-input v-model="dataForm.url" placeholder="资源url"></el-input>
          <el-upload
              class="upload-demo"
              :action=url
              :show-file-list="false"
              :before-upload="beforeUploadHandle"
              :on-success="successHandle">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          <div v-if="dataForm.url">
            <video v-if="dataForm.url!=''" :src="dataForm.url" ref="videoRef" width="400px" height="200px" controls
              style="margin: 30px 70px;"></video>
            <video v-else ref="videoRef" width="90%" style="margin: 30px 70px;" type="audio/wav"
              controls="controls"></video>
          </div>

      </el-form-item>
          <el-form-item label="第几集或者高清等显示" prop="name">
          <el-input v-model="dataForm.name" placeholder="第几集或者高清等显示"></el-input>
      </el-form-item>
      <el-form-item label="是否收费" prop="charge">
          <el-radio-group v-model="dataForm.charge">
              <el-radio :label="0">免费</el-radio>
              <el-radio :label="1">收费</el-radio>
            </el-radio-group>
          </el-form-item>
      <el-form-item label="下标" prop="sorts">
          <el-input v-model="dataForm.sorts" placeholder="下标,第一集就填0,以此类推"></el-input>
      </el-form-item>
          <el-form-item label="所属影视ID" prop="cartoonCode">
          <el-input v-model="dataForm.cartoonCode" :disabled="true" placeholder="所属影视ID"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      url: '',
      loading: '',
      dataForm: {
        id: '',
        url: '',
        name: '',
        sorts: '',
        charge: '',
        cartoonCode: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cartoonCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.url = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/oss/upload?token=${Cookies.get('token')}`
      this.visible = true
      if (this.dataForm.id) {
          this.getInfo()
        }
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/moviesinfo/moviesinfo/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
     // 上传之前
     beforeUploadHandle (file) {
       this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
       return true;
   },
       // 上传成功
   successHandle (res, file) {
     if(res.code == 0){
      this.loading.close();
       this.dataForm.url = res.data.src
     }else{
       return this.$message.error(res.msg)
     }
   },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/moviesinfo/moviesinfo/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
